import React from 'react';
import PropTypes from 'prop-types';

import Form from 'components/Admin/Prompts/Widget/Form';

import { useNavigate } from 'react-router-dom';

import { Modal } from 'react-bootstrap';

import actions from 'components/Admin/Prompts/Actions/Actions';

export default function Index({ refresh }) {
  const navigate = useNavigate();

  const onSave = (values, onSuccess, onError) => {
    actions.create(values, () => {
      onSuccess();
      refresh();
      navigate('/admin/prompts');
    }, onError);
  };

  const onClose = () => {
    navigate('/admin/prompts');
  };

  return (

    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create New Prompt</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSave={onSave}
          onClose={onClose}
          prompt={{
            message: '',
          }}
        />
      </Modal.Body>
    </Modal>

  );
}

Index.propTypes = {
  refresh: PropTypes.func.isRequired,
};
